// src/hooks/termOfPayments/useForceDeleteTermOfPayment.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteTermOfPayment } from "../../api/apiTermOfPayments";
import parseError from "../../utils/parseError";

const useForceDeleteTermOfPayment = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteTermOfPayments, isPending } = useMutation({
        mutationFn: forceDeleteTermOfPayment,
        onSuccess: (res) => {
            const message = res?.message || "Term of payment force deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["termOfPayments"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to force delete term of payment");
        },
    });

    return { forceDeleteTermOfPayments, isPending };
};

export default useForceDeleteTermOfPayment;